<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control' :disabled='disabled'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const PROTECTIVE_CAT = 'get_protective_cat.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'protectiveCat',
		data: function () { 
			return {
				selected: '',
				options: []
			}
		},
		props: {
			line_count: 0,
			type: '',
			id: null,
			disabled: false
		},
		methods: {
			change () {
				EventBus.$emit(`${this.type}_protective_cat`, {index: this.line_count, value: this.selected})
				//EventBus.$emit(`${this.type}_protective_cat_${this.line_count}`, this.selected)
			}
		},
		created: function () {
			if(this.$parent.data_location.protective_cat.length)
			{	
				this.options = this.$parent.data_location.protective_cat
				this.selected = this.$props.id ? this.$props.id : this.$parent.data_location.protective_cat[0].id

				EventBus.$emit(`${this.type}_protective_cat_${this.line_count}`, this.selected)
			} else {
				EventBus.$on('fetch_protective_cat_complete', () => {
					this.options = this.$parent.data_location.protective_cat
					this.selected = this.$props.id ? this.$props.id : protective_cat[0].id

					EventBus.$emit(`${this.type}_protective_cat_${this.line_count}`, this.selected)

					EventBus.$off('fetch_protective_cat_complete')
				})				
			}
			/*
			fetch(DB + PROTECTIVE_CAT, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.options = data
					this.selected = this.$props.id ? this.$props.id : data[0].id
				}
				else {
					this.options = []
				}
				EventBus.$emit(`${this.type}_protective_cat_${this.line_count}`, this.selected)
			})
			.catch(err => console.log(err))*/
		},
		beforeDestroy() {
			EventBus.$off('fetch_protective_cat_complete')
		}
	}
</script>


// WEBPACK FOOTER //
// protectiveCat.vue?4792f200